import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const searchByTerm = async (search, establecimientoId ) => {

  if(!establecimientoId){
    console.error("establecimientoId es required");
    return null;
  }

  const query = `
    query allInsumos(
      $search: String,
      $establecimiento: String,
      
    ) {
      allInsumos(
        search: $search,
        establecimiento: $establecimiento,
     
      ) {
        insumos {
          id
          token
          codigo
          presentacion
          nombre
          numMax
          establecimiento {
            id
            token
          }
          precioNeto
          precioTecho
        }
      }
    }
  `;

  const variables = {
    search,
    establecimiento : establecimientoId,
    estado : '1'
  };

  try {

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.allInsumos;

    if( response2.insumos.length === 0 ) return null;

    const data = response2.insumos;

    const dataMap = data.map(item => ({
      ...item,
      text: item.nombre,
      value: item.id
    }));
    
    return dataMap

  } catch (error) {
    console.error(error);
    return error;
  }
}

export const insumoService = {
  searchByTerm
}